import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Accordion, {
  AccordionItem,
  AccordionItemHeader,
  AccordionItemPanel,
} from 'src/components/common/Accordion';
import OrgTree from 'src/components/common/OrgTree';
import useOrgTreeState from 'src/components/common/OrgTree/hooks/useOrgTreeState';
import { CHECKBOX_MODE } from 'src/components/common/OrgTree/types';
import DateFilter from 'src/components/followUp/FilterColumn/DateFilter/DateFilter';
import { ORG_UNIT_CUSTOM_ORG_TREE_TEST_ID } from 'src/components/report/OrgUnitReportsPage';

import type { FilterSections } from './components/FilterColumn/FilterColumn';
import FilterColumn from './components/FilterColumn/FilterColumn';

interface SidebarProps {
  filterColumnSections?: FilterSections;
  noFilterColumn?: boolean;
}

const Sidebar: FC<SidebarProps> = ({ noFilterColumn }) => {
  const { t } = useTranslation('followUpActions');
  const orgTreeState = useOrgTreeState();

  return (
    <>
      <DateFilter />
      <Accordion
        initiallyActiveItems={[
          noFilterColumn
            ? 'org-tree-accordion-item'
            : 'table-filter-accordion-item',
        ]}
      >
        <AccordionItem
          itemName="org-tree-accordion-item"
          aria-label={t('OrgTree')}
        >
          <AccordionItemHeader headline={t('OrgTree')} />

          <AccordionItemPanel data-test-id={ORG_UNIT_CUSTOM_ORG_TREE_TEST_ID}>
            <OrgTree
              orgTreeState={orgTreeState}
              checkboxMode={CHECKBOX_MODE.MULTI}
            />
          </AccordionItemPanel>
        </AccordionItem>
        {!noFilterColumn && (
          <AccordionItem
            itemName="table-filter-accordion-item"
            aria-label={t('filter.title')}
          >
            <AccordionItemHeader headline={t('filter.title')} />
            <AccordionItemPanel>
              <FilterColumn />
            </AccordionItemPanel>
          </AccordionItem>
        )}
      </Accordion>
    </>
  );
};

export default Sidebar;
